'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createFormValues = require('./createFormValues');

var _createFormValues2 = _interopRequireDefault(_createFormValues);

var _plain = require('./structure/plain');

var _plain2 = _interopRequireDefault(_plain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createFormValues2.default)(_plain2.default);


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/formValues.js
 ** module id = 971
 ** module chunks = 0
 **/